module.exports = __webpack_public_path__ + "static/media/covidstories_cover3.3ee61716.jpg";